import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';

interface ChannelUserIdFilterProps {
  filterIndex: number;
}

/**
 * Renders a text input for filtering sessions by channel user ID
 */
export const ChannelUserIdFilter = ({ filterIndex }: ChannelUserIdFilterProps) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const channelUserId = useWatch({ control, name: `filters.${filterIndex}.channelUserId` }) || '';

  const handleChannelUserIdChange = (value: string) => {
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, channelUserId: value });
  };

  return (
    <Input
      id={`channel-user-id-${filterIndex}`}
      type="text"
      placeholder={t('analytics.filters.channelUserIdPlaceholder')}
      value={channelUserId}
      onChange={(e) => handleChannelUserIdChange(e.target.value)}
      className="w-full"
    />
  );
};
